const indexItems = [
  { icon: 'ri-fire-line', label: '今日热门', desc: '每日最火爆的爆料内容精选', color: 'text-primary-500 bg-primary-50' },
  { icon: 'ri-flashlight-line', label: '实时快讯', desc: '24小时不间断最新消息', color: 'text-accent-700 bg-accent-50' },
  { icon: 'ri-search-eye-line', label: '深度揭秘', desc: '行业内部深度调查报道', color: 'text-secondary-700 bg-secondary-100' },
  { icon: 'ri-chat-smile-2-line', label: '圈内爆料', desc: '各行业圈内一手消息', color: 'text-primary-600 bg-primary-50' },
  { icon: 'ri-vidicon-line', label: '视频爆料', desc: '现场直击视频内容专区', color: 'text-accent-700 bg-accent-50' },
  { icon: 'ri-bar-chart-box-line', label: '热度榜单', desc: '实时热度排名追踪', color: 'text-secondary-700 bg-secondary-100' },
  { icon: 'ri-earth-line', label: '全网聚合', desc: '多平台爆料内容汇总', color: 'text-primary-600 bg-primary-50' },
  { icon: 'ri-shield-check-line', label: '核实发布', desc: '经过多重核实的爆料内容', color: 'text-accent-700 bg-accent-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
            内容索引
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            爆料专题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            快速浏览51爆料网全部内容分类，按专题直达您关注的爆料领域
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${item.color} mb-4 transition-transform group-hover:scale-110`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                {item.label}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed hidden sm:block">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}